import React, { useState, useEffect } from 'react';
import { getTeamDashboard } from '../services/api';
import './ManagerDashboard.css';

function ManagerDashboard({ user }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('received');

  useEffect(() => {
    loadDashboard();
  }, [user.id]);

  async function loadDashboard() {
    try {
      const response = await getTeamDashboard(user.id);
      setData(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <div className="dashboard-loading">Loading team dashboard...</div>;
  }

  if (error) {
    return <div className="dashboard-error">{error}</div>;
  }

  if (!data || data.team.length === 0) {
    return (
      <div className="dashboard-empty">
        <h2>Manager Dashboard</h2>
        <p>You don't have any direct reports.</p>
      </div>
    );
  }

  const { team, recognitions_received, recognitions_given, stats } = data;

  return (
    <div className="manager-dashboard">
      <h2>Team Dashboard</h2>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{team.length}</div>
          <div className="stat-label">Team Members</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.total_received}</div>
          <div className="stat-label">Recognitions Received</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.total_given}</div>
          <div className="stat-label">Recognitions Given</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.total_badges}</div>
          <div className="stat-label">Badges Earned</div>
        </div>
      </div>

      <div className="team-members">
        <h3>Team Members</h3>
        <div className="team-grid">
          {team.map(member => (
            <div key={member.id} className="team-card">
              <div className="team-name">{member.name}</div>
              <div className="team-dept">{member.department}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="recognitions-section">
        <div className="tab-header">
          <button
            className={`tab-btn ${activeTab === 'received' ? 'active' : ''}`}
            onClick={() => setActiveTab('received')}
          >
            Received ({recognitions_received.length})
          </button>
          <button
            className={`tab-btn ${activeTab === 'given' ? 'active' : ''}`}
            onClick={() => setActiveTab('given')}
          >
            Given ({recognitions_given.length})
          </button>
        </div>

        <div className="recognitions-list">
          {(activeTab === 'received' ? recognitions_received : recognitions_given).map(rec => (
            <div key={rec.id} className="mini-recognition">
              <div className="mini-header">
                <span className="mini-giver">{rec.giver_name}</span>
                <span className="mini-arrow">→</span>
                <span className="mini-receiver">{rec.receiver_name}</span>
              </div>
              <div className="mini-message">{rec.message}</div>
              <div className="mini-date">
                {new Date(rec.created_at).toLocaleDateString()}
              </div>
            </div>
          ))}
          {(activeTab === 'received' ? recognitions_received : recognitions_given).length === 0 && (
            <div className="no-recognitions">No recognitions yet</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ManagerDashboard;
